import React from "react";
import { Outlet } from "react-router";

import NavLinker from "../../../components/NavLinker";

function VerificationPage() {
  return (
    <div className="flex flex-col gap-2 bg-white rounded-xl shadow-md  p-4">
      <div className="w-full  flex gap-2 items-center rounded-md  px-4 pt-4">
        <NavLinker to="" end>
          <span className=" font-medium  ">Pending</span>
        </NavLinker>
        <NavLinker to="all">
          <span className="font-medium  ">All</span>
        </NavLinker>
      </div>
      <div>
        <Outlet />
      </div>
    </div>
  );
}

export default VerificationPage;
